<template>
  <div>
    <slot name="botoes-adicionais" />
    <b-btn
      v-if="permissaoCreate"
      variant="none"
      class="btn btn-outline-primary mr-1"
      size="sm"
      @click="novo"
    >
      <feather-icon
        style="margin-right:0.25rem"
        icon="PlusIcon"
      />Novo
    </b-btn>
    <b-btn
      v-if="permissaoDelete && mostrarDeletar"
      :disabled="!linhasSelecionadas || linhasSelecionadas.length == 0"
      variant="none"
      size="sm"
      class="btn btn-outline-danger"
      @click="remover"
    >
      <feather-icon
        style="margin-right:0.25rem"
        icon="TrashIcon"
      />Remover
    </b-btn>
  </div>
</template>

<script>
export default {
  props: {
    permissaoCreate: {
      type: Boolean,
      default: false,
    },
    permissaoDelete: {
      type: Boolean,
      default: false,
    },
    linhasSelecionadas: {
      type: Array,
      default: null,
    },
    mostrarDeletar: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    novo() {
      this.$emit('novo')
    },
    remover() {
      this.$emit('remover')
    },
  },
}
</script>
